module.exports = __webpack_public_path__ + "static/media/HD-wallpaper-whatsapp-background-cool-dark-green-new-theme-whatsapp.34a48a89.jpg";